// components/layout/services-panel-desktop.jsx
'use client';

import CategoryList from '@/components/layout/services-ui/category-list';
import LinksPanel from '@/components/layout/services-ui/links-panel';
import PromoCard from '@/components/layout/services-ui/promo-card';

export default function DesktopServicesPanel({
    isLight,
    categories,
    activeCategory,
    setActiveCategory,
    onLinkClick,
    promo,
    closeDropdown,
}) {
    return (
        <div className="grid grid-cols-12 gap-4">
            {/* Left: categories */}
            <div className="col-span-3">
                <CategoryList
                    isLight={isLight}
                    categories={categories}
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                />
            </div>

            {/* Middle: links */}
            <div className="col-span-6">
                <LinksPanel
                    isLight={isLight}
                    category={categories[activeCategory]}
                    onLinkClick={onLinkClick}
                    closeDropdown={closeDropdown}
                />
            </div>

            {/* Right: promo */}
            <div className="col-span-3">
                <PromoCard isLight={isLight} promo={promo} closeDropdown={closeDropdown} />
            </div>
        </div>
    );
}
